import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { DisabledCancellationAireCardMenu } from 'shell/view-models/disabled-menu';

interface CardMenuProps {
  visibility?: DisabledCancellationAireCardMenu;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const CardMenu = ({
  visibility = {
    perditaCittadinanza: true,
    irreperibilitaPresunta: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: CardMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Cancellazione AIRE" />
      </ListItem>
      <Menu
        id="card-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {visibility.perditaCittadinanza
          ? [
              <MenuItem
                key="cancellazioneaire-perdita-cittadinanza-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/cancellazioni/cancellazione-aire/perdita-cittadinanza');
                }}
              >
                <Typography variant="inherit">{'Perdita Cittadinanza Italiana'}</Typography>
              </MenuItem>,
              <Divider
                key="perdita-cittadinanza-divider"
                hidden={!visibility.irreperibilitaPresunta}
              />,
            ]
          : undefined}
        {visibility.irreperibilitaPresunta
          ? [
              <MenuItem
                key="cancellazioneaire-irreperibilita-presunta-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/cancellazioni/cancellazione-aire/irreperibilita-presunta');
                }}
              >
                <Typography variant="inherit">Irreperibilità Presunta</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
    </Fragment>
  );
};

CardMenu.displayName = 'Card ID Menu';

export default CardMenu;
